import { Injectable } from '@angular/core';
import { createUUID } from '../../../core/utilities';
@Injectable({
  providedIn: 'root'
})
export class TrackingIDService {

  private $tracking:string = '';

  constructor() { }

  geaneratetracking(): void{
    this.$tracking = createUUID();
  }

  get trackingID(): string{
    return this.$tracking;
  } 


}
